<template>
    <div class="Projection">
        <transition @enter="enter" @leave="leave">
            <div ref="container" class="Projection__container">
                <video class="Projection__movie" ref="movie" loop>
                    
                    <!-- <source src="@/commons/videos/film.mp4" type="video/mp4"> -->
                    <!-- <source  src="@/commons/videos/test.mp4" type="video/mp4"> -->
                    <!-- <source :src="'https://meneath-v2.dpt.media/static/'+ $video +'.mp4'" type="video/mp4"> -->

                    <source 
                        :src="'https://meneath-v2.dpt.media/static/'+ $video +'.webm'"
                        type="video/webm"> 

                </video>   
                <div class="Projection__border"> 
                    <img :src="require('@/commons/images/frame.png')">
                </div> 
            </div>
        </transition>
        <Welcome v-if="is_welcome"/>
        <Instructions :room="$room" v-if="!is_playing && !is_welcome"/>
        <div class="Projection__cue"> : {{ current }}</div>
    </div>
</template>

<script>

import Welcome from '@/components/projection/Welcome'
import Instructions from '@/components/projection/Instructions'

export default {

    name: 'Projection',
    components: { Welcome, Instructions },
    data: ()=>({
        is_playing: false,
        cue: 0,
        laps: 300,
        delay: 1,
        is_welcome: true,
        is_playing: false,
        current: 0,
    }),  
    beforeDestroy() {
        this.$socket.emit('masterLeaveRoom', this.$room) 
        this.stopRAF()   
    },
    created(){
        this.$room = _.random(1000, 5000)
        this.$video = this.$route.params.video ? this.$route.params.video : 'onf_projection'
    },
    mounted() {
        TweenMax.delayedCall(this.delay, ()=>{
            if(this.$socket.connected)
                this.$socket.emit('joinSession', this.$room, 'projection')
        })
        document.addEventListener('keypress', this.onKeyPress)
    },
    computed: {
        start_movie() { return this.$store.getters['socket/start_movie'] },
        user_leave() { return this.$store.getters['socket/user_leave'] },
    },
    watch: {
        'is_playing'(nw){
            console.log('---');
            if(nw)
                this.startMovie()
        },
        start_movie(nw, od) {
            if(nw == true)
                this.is_playing = true
        },
        user_leave(nw, od){

            console.log('user_leave : '+ nw);

            if(nw == null)
                return
            
            this.stopRAF()
            this.$refs.movie.pause()  
            this.is_playing = false
        },
    },
    methods: {
        stopRAF() {
            cancelAnimationFrame(this.$raf)  
            this.cue = 0  
        },   
        restartMovie() {
            if(this.is_playing){
                this.stopRAF()
                this.$refs.movie.pause()  
                this.is_playing = false
            }
            else this.startMovie()
        },
        startMovie() {
            console.log('startMovie');
            this.$raf = requestAnimationFrame(this.onLoop)
            this.$refs.movie.play()
            this.$refs.movie.currentTime = this.current
            this.is_playing = true
        },

        continueMovie() {
            console.log('continueMovie');
            this.$refs.movie.play()
            this.$refs.movie.currentTime = this.current
            this.is_playing = true
            this.$raf = requestAnimationFrame(this.onLoop)
        },

        onLoop() {
            this.cue +=1
            if(this.cue == this.laps){
                this.cue = 0
                console.log(this.$refs.movie.currentTime);
                this.current = this.$refs.movie.currentTime
                this.$socket.emit('setTimeProjection', { room: this.$room, time: this.$refs.movie.currentTime, utc: Date.now() })   
            }
            this.$raf = requestAnimationFrame(this.onLoop)
        },

        enter(done) { done() },
        leave(done) { done() }, 

        onKeyPress() {
            console.log('onKeyPress');
            this.restartMovie()
        },
    }

}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.Projection
    overflow hidden
    position absolute
    width 100vw
    height 100%
    color white
    background black
    display flex 
    justify-content center
    align-items center

    &__container 
        width 100%
        max-width 880px
        position relative
        display flex 
        justify-content center
        align-items center

        height 100%

    &__movie
        overflow hidden
        position absolute
        top 50%
        left 50%
        transform translate(-50%, -50%)
        background-color white
        width 90%

    &__border 
        z-index 50
        position absolute
        width 1850px
        height 1235px
        top 50%
        transform: translateY(-47%)

    &__cue 
        position absolute
        top 0 
        left 0
        color white
        background black
        padding 4px 8px
        z-index 10000

</style>